// sizes for each grid-switcher mode: regular = 4 cols, large = 3 cols, xlarge = 2 cols at >=1200px (2/2/1 cols below that)
const GRID_COLUMN_SIZES = {
  regular: '(min-width: 1200px) calc(100vw / 4), calc(100vw / 2)',
  large: '(min-width: 1200px) calc(100vw / 3), calc(100vw / 2)',
  xlarge: '(min-width: 1200px) calc(100vw / 2), 100vw',
}

function updateProductCardSizes (columns) {
  const sizes = GRID_COLUMN_SIZES[columns] || GRID_COLUMN_SIZES.regular

  document.querySelectorAll('.prd-Card .rsp-Image_Image').forEach((image) => {
    image.sizes = sizes

    // Re-assigning srcset forces the browser to re-evaluate currentSrc against
    // the new sizes immediately, rather than waiting for the next natural reflow.
    // eslint-disable-next-line no-self-assign
    image.srcset = image.srcset
  })
}

window.addEventListener('grid-switcher:change', (event) => {
  updateProductCardSizes(event.detail.columns)
})
